<template>
	<transition name="expand">
		<div v-if="show" class="spinner-wrapper">
			<div class="spinner-container">
				<div class="logo"></div>
				<div class="spinner"></div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "StartViewSpinner",
	props: {
		show: Boolean
	},
	computed: {
		imagepathSpinner() {
			return require("@/assets/w3_startspinner_dots.png");
		},
		imagePathCSSspinner() {
			return "url(" + this.imagepathSpinner + ")";
		},
		imagepathLogo() {
			return require("@/assets/logo-patch_black.png");
		},
		imagePathCSSLogo() {
			return "url(" + this.imagepathLogo + ")";
		}
	}
};
</script>

<style scoped>
/* WRAPPER = påverkar layout */
.spinner-wrapper {
	width: 100%;
	height: 120px;

	display: flex;
	justify-content: center;
	align-items: center;

	overflow: hidden;
}

/* INNEHÅLL = skalas visuellt */
.spinner-container {
	position: relative;
	width: 120px;
	height: 120px;

	border-radius: 50%;

	transform-origin: center;
}

/* LOGGA */
.logo {
	position: absolute;
	inset: 0;

	background-image: v-bind(imagePathCSSLogo);
	background-size: 50%;
	background-repeat: no-repeat;
	background-position: center;
}

/* SPINNER */
.spinner {
	position: absolute;
	inset: 0;

	background-image: v-bind(imagePathCSSspinner);
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;

	animation: spin 2s linear infinite;
}

/* ROTATION */
@keyframes spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}

.expand-enter-active,
.expand-leave-active {
	transition: height 0.3s ease, opacity 0.2s ease;
}

/* wrapper krymper + fade */
.expand-enter-from,
.expand-leave-to {
	height: 0;
	opacity: 0;
}

.expand-enter-to,
.expand-leave-from {
	height: 120px;
	opacity: 1;
}

/* inner scale + fade */
.expand-enter-active .spinner-container,
.expand-leave-active .spinner-container {
	transition: transform 0.3s ease, opacity 0.2s ease;
}

.expand-enter-from .spinner-container,
.expand-leave-to .spinner-container {
	transform: scale(0);
	opacity: 0;
}

.expand-enter-to .spinner-container,
.expand-leave-from .spinner-container {
	transform: scale(1);
	opacity: 1;
}
</style>